<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-协议分类-添加
    -->
    <el-dialog
    title="添加协议分类"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

      <el-form-item label="协议分类名称" prop="name"><el-input v-model="form.name" placeholder="请输入协议分类名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
 </div>
</el-dialog>
  
</template>

<script>
import Ma_protocol_classificationApi from '@/api/ma_protocol_classification.js';

export default {
  components: {
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        sort: 50,
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入协议分类名称', trigger: 'blur' }],
      },
      dialogVisible: false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_protocol_classificationApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_protocol_classification/index/part/add.vue